import { render, staticRenderFns } from "./AlportConsentContainer.vue?vue&type=template&id=31d0b2ff"
import script from "./AlportConsentContainer.vue?vue&type=script&lang=js"
export * from "./AlportConsentContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports